import React from 'react';
import styled from 'styled-components';
import { ScaleLoader } from 'react-spinners';

const LoadingBackground = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 51, 149, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
`

const Loading = (props) => {

  return (
    <LoadingBackground>
      <ScaleLoader color={'#ffffff'} loading={props.loading} />
    </LoadingBackground>
  )
}


export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js